<template lang="pug">
  .groupped-objects
    e-toolbar(
      :hideRemoveButton="true"
      :hideAddButton="true"
      :showViewPanel="false"
      :showTotal="true"
      :items="items"
      :hideImportBtn="true"
    )
      .parameter.parameter--right(slot="searchResult")
        .display-flex(style='gap:10px; align-items:flex-end')
          router-link.reset-btn.button(:to="{name:'atu.objects'}") Разгруппировать
          e-form-group.filter-block(
            style="margin-bottom:0"
            inputType="select"
            :inputStyle="{'width':'auto'}"
            :formValidator="formValidator"
            label="Группировать по"
            name="_groupBy"
            :model="filterModel"
            tabView="tab1"
            :options="groupByOptions"
            @change="changeGroupedBy"
          )
          .popup-list(v-show='filterModel._groupBy === GROUP_BY_DANGER')
            button(
              :title="$translate('Отобразить категории')"
              @click.stop="showDangerPopup = !showDangerPopup"
            ).reset-btn.popup-list__button.view-panel__button_list.view-panel__button
            .filter-popup.popup-list__popup(v-show="showDangerPopup" @click.stop="")
              e-perfect-scrollbar
                .item.filter-popup__item(v-for="(item, fieldName) in dangerList")
                  .custom-checkbox
                    input.checkbox.custom-checkbox__input.visually-hidden(
                      type="checkbox"
                      :id="'checkbox-' + fieldName"
                      v-model="selectedDanger"
                      @change="changeSelecteDanger(item.id)"
                      :value="item.id"
                    )
                    label.custom-checkbox__label(:for="'checkbox-' + fieldName")
                      .custom-checkbox__block
                      .custom-checkbox__text {{ dangerList[fieldName].name }}
          .popup-list(v-show='filterModel._groupBy === GROUP_BY_FKKO')
            button(
              :title="$translate('Отобразить категории')"
              @click.stop="showFkkoPopup = !showFkkoPopup"
            ).reset-btn.popup-list__button.view-panel__button_list.view-panel__button
            .filter-popup.popup-list__popup(v-show="showFkkoPopup" @click.stop="")
              e-perfect-scrollbar
                .item.filter-popup__item(v-for="item in fkkoList")
                  .custom-checkbox
                    input.checkbox.custom-checkbox__input.visually-hidden(
                      type="checkbox"
                      :id="'checkbox-' + item.id"
                      v-model="selectedFkko"
                      @change="event => changeSelectedFkko(event, item)"
                      :value="item.id"
                    )
                    label.custom-checkbox__label(:for="'checkbox-' + item.id")
                      .custom-checkbox__block
                      .custom-checkbox__text {{ item.name }}
      div(slot="filter-status")
        .display-flex(style='gap: 10px')
          .columns-list
            button.reset-btn.btn-columns.view-panel__button.view-panel__button_columns(
              @click.stop="showColumnsPopup = !showColumnsPopup"
              title="Отобразить столбцы"
              style='margin-right: 0')
            .filter-popup.columns-list__popup(v-show="showColumnsPopup" @click.stop="")
              e-perfect-scrollbar
                .item.filter-popup__item(v-for="item in visibleColumns")
                  .custom-checkbox
                    input.checkbox.custom-checkbox__input.visually-hidden(
                      type="checkbox"
                      :id="'checkbox-' + item.id"
                      v-model="item.visible"
                      :value="item.id"
                    )
                    label.custom-checkbox__label(:for="'checkbox-' + item.id")
                      .custom-checkbox__block
                      .custom-checkbox__text {{ item.name }}
          select.select.e-year-select(v-model="year_from" @change="changeYear")
            option(v-for="option in yearsOptions" :value="option") {{option}}
          select.select.e-year-select(v-model="year_to" @change="changeYear")
            option(v-for="option in yearsOptions" :value="option") {{option}}
    .content.overflow-visible.max-height-initial
      .atu-table
        e-perfect-scrollbar(
          :emitTypes="['vue']"
          :config="{suppressScrollY: false, suppressScrollX: false}"
          class="real-table-scrollbar"
        )
          .atu-table__header
            .atu-table__row
              .atu-table__head
              .atu-table__head.semibold ФККО
              .atu-table__head.semibold.atu-table__head_has-children.justify-center(v-for="item in yearColumns" :style="calcColumnWidth()")
                span.text-center {{item}}
                .atu-table__row.groupped-objects__long-row
                  .atu-table__head-inner(v-for="item in visibleColumns.filter(el => el.visible)" ) {{item.name}}
          // таблица при сортировке по классу опасности
          .atu-table__body(v-if="filterModel._groupBy === 'danger_class'")
            .atu-table__row
              .atu-table__col Всего
              .atu-table__col
              template(v-for='item in yearColumns')
                .atu-table__col(v-for="column in visibleColumns.filter(el => el.visible)" )
                  span(v-if="dangerYears[item]") {{toFloatFixed(dangerYears[item][column.id])}}
            .atu-table__row(v-for='(value, key) in grouppedByDanger')
              // отображение если список не раскрыт
              template(v-if="!activeDanger.includes(key)")
                .atu-table__col(@click='toggleActiveDanger(key)')
                  .display-flex.align-items-center.pointer
                    button.reset-btn.arrow.atu-table__arrow(:class="activeDanger.includes(key) ? 'arrow_opened' : ''")
                    .text.sortable__text Класс опасности {{key}}
                .atu-table__col
                template(v-for='year in value.years')
                  .atu-table__col(v-for="column in visibleColumns.filter(el => el.visible)" ) {{toFloatFixed(year[column.id])}}
              // отображение при раскрытом списке
              template(v-else)
                .atu-table__col(@click='toggleActiveDanger(key)')
                  .atu-table__col-inner.display-flex.align-items-center.pointer
                    button.reset-btn.arrow.atu-table__arrow(:class="activeDanger.includes(key) ? 'arrow_opened' : ''")
                    .text.sortable__text Класс опасности {{key}}
                  template(v-for='mo in value.mo')
                    .atu-table__col-inner.atu-table__mo-name {{mo.name}}
                    .atu-table__col-inner(v-for='count in countInnerRows(mo.years)')
                .atu-table__col
                  .atu-table__col-inner
                  template(v-for='mo in value.mo')
                    .atu-table__col-inner
                    .atu-table__col-inner(v-for='el in Object.values(mo.years)[0].wastes') {{el.code}}
                template(v-for='(year, key) in value.years')
                  // Численность населения
                  .atu-table__col(v-if="isVisibleColumn('population')")
                    .atu-table__col-inner {{toFloatFixed(year.population)}}
                    template(v-for='(el, elKey) in value.mo')
                      .atu-table__col-inner(
                        title='Чтобы отредактировать значение используйте двойной клик'
                        @dblclick='setEditedPopulations([elKey, key])'
                      )
                        span(v-if="!editedPopulations.includes(`${elKey}_${key}`)") {{el.years[key].population}}
                        input.input(
                          v-else
                          title="Нажмите Enter чтобы сохранить"
                          :value='el.years[key].population'
                          @keyup.enter='e => setPopulationValue(e, elKey, key)'
                        )
                      .atu-table__col-inner(v-for='i in Object.keys(el.years[key].wastes).length')
                  // Количество образованных отходов
                  .atu-table__col.fgh(v-if="isVisibleColumn('total')")
                    .atu-table__col-inner {{toFloatFixed(year.total)}}
                    template(v-for='(el, atuKey) in value.mo')
                      .atu-table__col-inner {{countWastesByParameter(el.years[key].wastes, 'total')}}
                      .atu-table__col-inner(
                        v-for='(fkko, fkkoKey) in el.years[key].wastes'
                        title='Чтобы отредактировать значение используйте двойной клик'
                        @dblclick='setEditedParameter([atuKey, fkkoKey, key], "total")'
                      )
                        span(v-if="!editedParameters.total.includes(`${atuKey}_${fkkoKey}_${key}`)") {{toFloatFixed(Number(fkko.total))}}
                        input.input(
                          v-else
                          title="Нажмите Enter чтобы сохранить"
                          :value='toFloatFixed(Number(fkko.total))'
                          @keyup.enter='e => setParameter(e, [atuKey, fkkoKey, key], "total")'
                        )
                  // Количество переработанных отходов
                  .atu-table__col(v-if="isVisibleColumn('total_recast')")
                    .atu-table__col-inner {{toFloatFixed(year.total_recast)}}
                    template(v-for='(el, atuKey) in value.mo')
                      .atu-table__col-inner {{countWastesByParameter(el.years[key].wastes, 'total_recast')}}
                      .atu-table__col-inner(
                        v-for='(fkko, fkkoKey) in el.years[key].wastes'
                        title='Чтобы отредактировать значение используйте двойной клик'
                        @dblclick='setEditedParameter([atuKey, fkkoKey, key], "total_recast")'
                      )
                        span(v-if="!editedParameters.total_recast.includes(`${atuKey}_${fkkoKey}_${key}`)") {{toFloatFixed(Number(fkko.total_recast))}}
                        input.input(
                          v-else
                          title="Нажмите Enter чтобы сохранить"
                          :value='toFloatFixed(Number(fkko.total_recast))'
                          @keyup.enter='e => setParameter(e, [atuKey, fkkoKey, key], "total_recast")'
                        )
                  // Количество захороненных отходов
                  .atu-table__col(v-if="isVisibleColumn('total_storage')")
                    .atu-table__col-inner {{toFloatFixed(year.total_storage)}}
                    template(v-for='(el, atuKey) in value.mo')
                      .atu-table__col-inner {{countWastesByParameter(el.years[key].wastes, 'total_storage')}}
                      .atu-table__col-inner(
                        v-for='(fkko, fkkoKey) in el.years[key].wastes'
                        title='Чтобы отредактировать значение используйте двойной клик'
                        @dblclick='setEditedParameter([atuKey, fkkoKey, key], "total_storage")'
                      )
                        span(v-if="!editedParameters.total_storage.includes(`${atuKey}_${fkkoKey}_${key}`)") {{toFloatFixed(Number(fkko.total_storage))}}
                        input.input(
                          v-else
                          title="Нажмите Enter чтобы сохранить"
                          :value='toFloatFixed(Number(fkko.total_storage))'
                          @keyup.enter='e => setParameter(e, [atuKey, fkkoKey, key], "total_storage")'
                        )
                // столбец для перехода в редактирование карточки
                .atu-table__col.atu-table__col_sticky
                  .atu-table__col-inner
                  template(v-for='(el, key) in value.mo')
                    .atu-table__col-inner
                      router-link.reset-btn.button.button_edit.button_small.button_icon(:to='getPathToUpdate(key)')
                    .atu-table__col-inner(v-for='i in  Object.keys(Object.values(el.years)[0].wastes)')
          // таблица при сортировке по ФККО
          .atu-table__body(v-else)
            .atu-table__row
              .atu-table__col Всего
              .atu-table__col
              template(v-for='item in yearColumns')
                .atu-table__col(v-for="column in visibleColumns.filter(el => el.visible)" )
                  span(v-if='fkkoYears[item]') {{countAllParameters(item, column)}}
          .atu-table__row(v-for='(value, key) in grouppedByFkko')
            // отображение если список не раскрыт
            template(v-if="!activeMo.includes(key)")
              .atu-table__col(@click='toggleActiveMo(key)')
                .display-flex.align-items-center.pointer
                  button.reset-btn.arrow.atu-table__arrow(:class="activeMo.includes(key) ? 'arrow_opened' : ''")
                  .atu-table__mo-name.atu-table__mo-name_fkko {{value.name}}
              // ФККО
              .atu-table__col
              template(v-for='(year, yearKey) in value.years')
                // Общая численность населения
                .atu-table__col
                  .atu-table__col-inner(
                    title='Чтобы отредактировать значение используйте двойной клик'
                    @dblclick='setEditedPopulations([key,yearKey])'
                  )
                    span(v-if="!editedPopulations.includes(`${key}_${yearKey}`)") {{year.population}}
                    input.input(
                      v-else
                      title="Нажмите Enter чтобы сохранить"
                      :value='year.population'
                      @keyup.enter='e => setPopulationValue(e, key, yearKey)'
                    )
                // Общее количество образованных отходов
                .atu-table__col
                  .atu-table__col-inner {{countFkkoWastesByParameter(year.wastes, 'total')}}
                // Общее количество переработанных отходов
                .atu-table__col
                  .atu-table__col-inner {{countFkkoWastesByParameter(year.wastes, 'total_recast')}}
                // Общее количество захороненных отходов
                .atu-table__col
                  .atu-table__col-inner {{countFkkoWastesByParameter(year.wastes, 'total_storage')}}
                    // столбец для перехода в редактирование карточки
              .atu-table__col.atu-table__col_sticky
                .atu-table__col-inner
                  router-link.reset-btn.button.button_edit.button_small.button_icon(:to='getPathToUpdate(key)')
            // отображение при раскрытом списке
            template(v-else)
              .atu-table__col(@click='toggleActiveMo(key)')
                .atu-table__col-inner
                  .display-flex.align-items-center.pointer
                    button.reset-btn.arrow.atu-table__arrow(:class="activeMo.includes(key) ? 'arrow_opened' : ''")
                    .atu-table__mo-name.atu-table__mo-name_fkko {{value.name}}
                template(v-for='(danger, key) in value.dangers')
                  template(v-for='year in danger')
                    .atu-table__col-inner Класс опасности {{key}}
                    template(v-for='(waste, wasteKey) in year')
                      .atu-table__col-inner(v-if="selectedFkko.includes(wasteKey)")
              // ФККО
              .atu-table__col
                .atu-table__col-inner
                template(v-for='(danger, key) in value.dangers')
                  template(v-for='(year, yearKey) in danger')
                    .atu-table__col-inner
                    template(v-for='(waste, wasteKey) in year')
                      .atu-table__col-inner(v-if="selectedFkko.includes(wasteKey)") {{waste.code}}
              template(v-for='(year, yearKey) in value.years')
                // Численность населения
                .atu-table__col
                  .atu-table__col-inner(
                    title='Чтобы отредактировать значение используйте двойной клик'
                    @dblclick='setEditedPopulations([key, yearKey])'
                  )
                    span(v-if="!editedPopulations.includes(`${key}_${yearKey}`)") {{year.population}}
                    input.input(
                      v-else
                      title="Нажмите Enter чтобы сохранить"
                      :value='year.population'
                      @keyup.enter='e => setPopulationValue(e, key, yearKey)'
                    )
                  template(v-for='danger in Object.values(year.wastes)')
                    .atu-table__col-inner
                    template(v-for='(waste) in Object.values(danger)')
                      .atu-table__col-inner
                // Количество образованных отходов
                .atu-table__col
                  .atu-table__col-inner {{countFkkoWastesByParameter(year.wastes, 'total')}}
                  template(v-for='danger in Object.values(year.wastes)')
                    .atu-table__col-inner {{countWastesByParameter(danger, 'total')}}
                    template(v-for='(waste, wasteKey) in danger')
                      .atu-table__col-inner(
                        v-if="selectedFkko.includes(wasteKey)"
                        title='Чтобы отредактировать значение используйте двойной клик'
                        @dblclick='setEditedParameter([key, wasteKey, yearKey], "total")'
                      )
                        span(v-if="!editedParameters.total.includes(`${key}_${wasteKey}_${yearKey}`)") {{toFloatFixed(Number(waste.total))}}
                        input.input(
                          v-else
                          title="Нажмите Enter чтобы сохранить"
                          :value='toFloatFixed(Number(waste.total))'
                          @keyup.enter='e => setParameter(e, [key, wasteKey, yearKey], "total")'
                        )
                // Количество переработанных отходов
                .atu-table__col
                  .atu-table__col-inner {{countFkkoWastesByParameter(year.wastes, 'total_recast')}}
                  template(v-for='danger in Object.values(year.wastes)')
                    .atu-table__col-inner {{countWastesByParameter(danger, 'total_recast')}}
                    template(v-for='(waste, wasteKey) in danger')
                      .atu-table__col-inner(
                        v-if="selectedFkko.includes(wasteKey)"
                        title='Чтобы отредактировать значение используйте двойной клик'
                        @dblclick='setEditedParameter([key, wasteKey, yearKey], "total_recast")'
                      )
                        span(v-if="!editedParameters.total_recast.includes(`${key}_${wasteKey}_${yearKey}`)") {{toFloatFixed(Number(waste.total_recast))}}
                        input.input(
                          v-else
                          title="Нажмите Enter чтобы сохранить"
                          :value='toFloatFixed(Number(waste.total_recast))'
                          @keyup.enter='e => setParameter(e, [key, wasteKey, yearKey], "total_recast")'
                        )
                // Количество захороненных отходов
                .atu-table__col
                  .atu-table__col-inner {{countFkkoWastesByParameter(year.wastes, 'total_storage')}}
                  template(v-for='danger in Object.values(year.wastes)')
                    .atu-table__col-inner {{countWastesByParameter(danger, 'total_storage')}}
                    template(v-for='(waste, wasteKey) in danger')
                      .atu-table__col-inner(
                        v-if="selectedFkko.includes(wasteKey)"
                        title='Чтобы отредактировать значение используйте двойной клик'
                        @dblclick='setEditedParameter([key, wasteKey, yearKey], "total_storage")'
                      )
                        span(v-if="!editedParameters.total_storage.includes(`${key}_${wasteKey}_${yearKey}`)") {{toFloatFixed(Number(waste.total_storage))}}
                        input.input(
                          v-else
                          title="Нажмите Enter чтобы сохранить"
                          :value='toFloatFixed(Number(waste.total_storage))'
                          @keyup.enter='e => setParameter(e, [key, wasteKey, yearKey], "total_storage")'
                        )
              .atu-table__col.atu-table__col_sticky
                .atu-table__col-inner
                  router-link.reset-btn.button.button_edit.button_small.button_icon(:to='getPathToUpdate(key)')
</template>
<script>
import { atu } from '@/api/api-endpoints'
import year from '@/utils/year'
import RouteMixin from '@/mixins/route-mixin'
import hasMixin from '@/mixins/has-mixin'
import FormValidator from '@/components/form/form-validator'
import { toFloatFixed } from '@/utils'
import url from '@/utils/url'

const DEFAULT_YEAR = year.getCurrentYear()
const GROUP_BY_FKKO = 'mo'
const GROUP_BY_DANGER = 'danger_class'

export default {
  mixins: [RouteMixin, hasMixin],
  data() {
    return {
      formValidator: new FormValidator(),
      year_from: DEFAULT_YEAR,
      year_to: DEFAULT_YEAR + 1,
      filterModel: {
        _groupBy: GROUP_BY_FKKO,
      },
      items: {},
      activeDanger: [],
      activeMo: [],
      showDangerPopup: false,
      showFkkoPopup: false,
      selectedDanger: [],
      selectedFkko: [],
      visibleColumns: [
        {
          id: 'population',
          name: 'Численность населения, чел',
          visible: true,
        },
        {
          id: 'total',
          name: 'Количество образованных отходов, т',
          visible: true,
        },
        {
          id: 'total_recast',
          name: 'Количество переработанных отходов, т',
          visible: true,
        },
        {
          id: 'total_storage',
          name: 'Количество захороненных отходов, т',
          visible: true,
        },
      ],
      showColumnsPopup: false,
      editedPopulations: [],
      editedParameters: {
        total: [],
        total_recast: [],
        total_storage: [],
      },
      minusParameters: {},
    }
  },
  computed: {
    GROUP_BY_DANGER() {
      return GROUP_BY_DANGER
    },
    GROUP_BY_FKKO() {
      return GROUP_BY_FKKO
    },
    groupByOptions() {
      return [
        { id: GROUP_BY_DANGER, name: 'Классу опасности' },
        { id: GROUP_BY_FKKO, name: 'Фкко' },
      ]
    },
    countVisibleColumns() {
      return this.visibleColumns.filter((item) => item.visible).length
    },
    yearsOptions() {
      let columnsarr = []
      const currentYear = year.getCurrentYear()
      for (let i = currentYear; i <= currentYear + 10; i++) {
        columnsarr.push(i)
      }
      return columnsarr
    },
    yearColumns() {
      let columnsarr = []
      if (!this.items.data) {
        return
      }
      for (let i = this.year_from; i <= this.year_to; i++) {
        columnsarr.push(i)
      }
      return columnsarr
    },
    grouppedByDanger() {
      if (!this.items.data || this.filterModel._groupBy !== GROUP_BY_DANGER) {
        return
      }
      let columnsarr = JSON.parse(JSON.stringify(this.items.data))

      Object.values(columnsarr).forEach((value) => {
        value.years = {}
        value.active = false
        value.mo = {}
        Object.entries(value).forEach(([key, el]) => {
          if (el.years) {
            value.mo[key] = el
            for (let i = this.year_from; i <= this.year_to; i++) {
              if (value.years[i]) {
                value.years[i].population += el.years[i]?.population || 0
              } else {
                value.years[i] = {
                  population: el.years[i]?.population || 0,
                  total: 0,
                  total_recast: 0,
                  total_storage: 0,
                }
              }
              if (el.years[i]) {
                Object.values(el.years[i].wastes).forEach((res) => {
                  value.years[i].total += Number(res.total)
                  value.years[i].total_recast += Number(res.total_recast)
                  value.years[i].total_storage += Number(res.total_storage)
                })
              } else {
                el.years[i] = {
                  population: 0,
                }
                el.years[i].wastes = JSON.parse(
                  JSON.stringify(el.years[i - 1].wastes)
                )
                Object.values(el.years[i].wastes).forEach((res) => {
                  res.total = 0
                  res.total_recast = 0
                  res.total_storage = 0
                })
              }
            }
          }
        })
      })
      if (this.selectedDanger.includes('all')) {
        return columnsarr
      } else {
        Object.keys(columnsarr).forEach((key) => {
          if (!this.selectedDanger.includes(key)) {
            delete columnsarr[key]
          }
        })
      }
      return columnsarr
    },
    dangerList() {
      if (!this.items.data) {
        return
      }
      let result = []
      const arr = JSON.parse(JSON.stringify(this.items.data))
      if (this.filterModel._groupBy === GROUP_BY_DANGER) {
        result = Object.keys(arr).map((item) => {
          return { id: item, name: item }
        })
      }
      result.unshift({ id: 'all', name: 'Все' })
      this.selectedDanger = result.map((item) => item.id)
      return result
    },
    dangerYears() {
      const obj = {}
      Object.values(this.grouppedByDanger).forEach((value) => {
        if (value.years) {
          Object.entries(value.years).forEach(([yearKey, year]) => {
            if (obj[yearKey]) {
              obj[yearKey].population += year.population
              obj[yearKey].total += Number(year.total)
              obj[yearKey].total_recast += Number(year.total_recast)
              obj[yearKey].total_storage += Number(year.total_storage)
            } else {
              obj[yearKey] = {
                population: year.population,
                total: Number(year.total),
                total_recast: Number(year.total_recast),
                total_storage: Number(year.total_storage),
              }
            }
          })
        }
      })
      return obj
    },
    grouppedByFkko() {
      if (!this.items.data || this.filterModel._groupBy !== GROUP_BY_FKKO) {
        return
      }

      let columnsarr = JSON.parse(JSON.stringify(this.items.data))
      Object.values(columnsarr).forEach((value) => {
        value.active = false
        value.dangers = {}
        if (value.years) {
          for (let i = this.year_from; i <= this.year_to; i++) {
            if (!value.years[i]) {
              value.years[i] = {
                population: 0,
                total: 0,
                total_recast: 0,
                total_storage: 0,
              }
            }

            if (value.years[i].wastes) {
              value.years[i].total = 0
              value.years[i].total_recast = 0
              value.years[i].total_storage = 0
              Object.entries(value.years[i].wastes).forEach(([danger, res]) => {
                if (!Object.keys(value.dangers).includes(danger)) {
                  value.dangers[danger] = {
                    [i]: res,
                  }
                }
                Object.values(res).forEach((j) => {
                  value.years[i].total += Number(j.total)
                  value.years[i].total_recast += Number(j.total_recast)
                  value.years[i].total_storage += Number(j.total_storage)
                })
              })
            } else {
              value.years[i] = {
                population: 0,
                total: 0,
                total_recast: 0,
                total_storage: 0,
              }
              value.years[i].wastes = JSON.parse(
                JSON.stringify(value.years[i - 1].wastes)
              )
              Object.values(value.years[i].wastes).forEach((res) => {
                Object.values(res).forEach((j) => {
                  j.total = 0
                  j.total_recast = 0
                  j.total_storage = 0
                })
              })
            }
          }
        }
      })
      return columnsarr
    },
    fkkoYears() {
      const obj = {}
      Object.values(this.grouppedByFkko).forEach((value) => {
        if (value.years) {
          Object.entries(value.years).forEach(([yearKey, year]) => {
            if (obj[yearKey]) {
              obj[yearKey].population += year.population
              obj[yearKey].total += Number(year.total) || 0
              obj[yearKey].total_recast += Number(year.total_recast) || 0
              obj[yearKey].total_storage += Number(year.total_storage) || 0
            } else {
              obj[yearKey] = {
                population: year.population,
                total: Number(year.total) || 0,
                total_recast: Number(year.total_recast) || 0,
                total_storage: Number(year.total_storage) || 0,
              }
            }
          })
        }
      })
      return obj
    },
    fkkoList() {
      const obj = {}
      if (!this.grouppedByFkko) {
        return
      }
      Object.values(this.grouppedByFkko).forEach((value) => {
        if (value.years) {
          Object.entries(value.years).forEach(([yearKey, year]) => {
            Object.values(year).forEach((dangers) => {
              if (dangers && typeof dangers === 'object') {
                Object.values(dangers).forEach((item) => {
                  Object.entries(item).forEach(([id, fkko]) => {
                    if (!obj[id]) {
                      obj[id] = {
                        id,
                        name: fkko.code,
                        total: Number(fkko.total),
                        total_recast: Number(fkko.total_recast),
                        total_storage: Number(fkko.total_storage),
                        year: yearKey,
                      }
                    } else {
                      obj[id].total += Number(fkko.total)
                      obj[id].total_recast += Number(fkko.total_recast)
                      obj[id].total_storage += Number(fkko.total_storage)
                    }
                  })
                })
              }
            })
          })
        }
      })
      const arr = Object.values(obj)
      arr.unshift({ id: 'all', name: 'Все' })
      this.selectedFkko = arr.map((item) => item.id)
      return arr
    },
  },
  watch: {
    $route: 'onRoute',
  },
  methods: {
    toFloatFixed(value) {
      return toFloatFixed(value)
    },
    changeGroupedBy() {
      this.getData()
      this.editedPopulations = []
    },
    getEndpoint(route) {
      route.query.year_from = this.year_from
        ? this.year_from
        : year.getCurrentYear()
      route.query.year_to = this.year_to ? this.year_to : year.getCurrentYear()
      route.query.group_by = this.filterModel._groupBy

      return atu.wastes(route)
    },
    changeTariffYearSelect(year) {
      this.year = year
      this.replaceRoute({ year }, false)
      this.getData()
    },
    async getData() {
      this.$bar.start()
      this.items = await this.$store.dispatch('updateUrlEndpoint', {
        endpoint: this.getEndpoint(this.$route),
      })
      this.$bar.finish()
    },
    changeYear() {
      this.getData()
    },
    toggleActiveDanger(danger) {
      if (this.activeDanger.includes(danger)) {
        const index = this.activeDanger.indexOf(danger)
        this.activeDanger.splice(index, 1)
      } else {
        this.activeDanger.push(danger)
      }
    },
    toggleActiveMo(mo) {
      if (this.activeMo.includes(mo)) {
        const index = this.activeMo.indexOf(mo)
        this.activeMo.splice(index, 1)
      } else {
        this.activeMo.push(mo)
      }
    },
    changeSelecteDanger(element) {
      const allDangers = this.dangerList.map((item) => item.id)
      const allDangersWithoutAll = allDangers.filter((item) => item !== 'all')
      let withoutAll = false
      allDangersWithoutAll.forEach((item) => {
        if (!this.selectedDanger.includes(item) && element !== 'all') {
          withoutAll = true
        }
      })

      if (withoutAll) {
        const indexAll = this.selectedDanger.findIndex((item) => item === 'all')
        if (indexAll >= 0) {
          this.selectedDanger.splice(indexAll, 1)
        }
      } else {
        this.selectedDanger.unshift('all')
      }

      if (this.selectedDanger.includes('all')) {
        this.selectedDanger = this.selectedDanger.concat(allDangers)
        this.selectedDanger = Array.from(new Set(this.selectedDanger))
      }
    },
    changeSelectedFkko(event, element) {
      if (element.id !== 'all') {
        if (!event.target.checked) {
          if (!this.minusParameters[element.year]) {
            this.minusParameters[element.year] = {
              total: Number(element.total),
              total_recast: Number(element.total_recast),
              total_storage: Number(element.total_storage),
            }
          } else {
            this.minusParameters[element.year].total += Number(element.total)
            this.minusParameters[element.year].total_recast += Number(
              element.total_recast
            )
            this.minusParameters[element.year].total_storage += Number(
              element.total_storage
            )
          }
        } else {
          this.minusParameters[element.year].total -= Number(element.total)
          this.minusParameters[element.year].total_recast -= Number(
            element.total_recast
          )
          this.minusParameters[element.year].total_storage -= Number(
            element.total_storage
          )
        }
      }

      const id = element.id
      const allFkko = this.fkkoList.map((item) => item.id)
      const allFkkoWithoutAll = allFkko.filter((item) => item !== 'all')
      let withoutAll = false
      allFkkoWithoutAll.forEach((item) => {
        if (!this.selectedFkko.includes(item) && id !== 'all') {
          withoutAll = true
        }
      })
      if (withoutAll) {
        const indexAll = this.selectedFkko.findIndex((el) => el === 'all')
        if (indexAll >= 0) {
          this.selectedFkko.splice(indexAll, 1)
        }
      } else {
        this.selectedFkko.unshift('all')
      }

      if (this.selectedFkko.includes('all')) {
        this.selectedFkko = this.selectedFkko.concat(allFkko)
        if (event.target.checked) {
          Object.values(this.minusParameters).forEach((item) => {
            item.total = 0
            item.total_recast = 0
            item.total_storage = 0
          })
        }
      }
      this.selectedFkko = Array.from(new Set(this.selectedFkko))
    },
    outerClick() {
      this.showFkkoPopup = false
      this.showDangerPopup = false
      this.showColumnsPopup = false
    },
    countInnerRows(value) {
      let count = 0
      Object.values(value).forEach((item) => {
        count = Object.keys(item.wastes).length
      })
      return count
    },
    countWastesByParameter(wastes, parameter) {
      let count = 0
      Object.entries(wastes).forEach(([key, item]) => {
        if (this.selectedFkko.includes(key)) {
          count += Number(item[parameter])
        }
      })
      return toFloatFixed(count)
    },
    countFkkoWastesByParameter(wastes, parameter) {
      let count = 0
      Object.values(wastes).forEach((item) => {
        Object.entries(item).forEach(([key, el]) => {
          if (this.selectedFkko.includes(key)) {
            count += Number(el[parameter])
          }
        })
      })
      return toFloatFixed(count)
    },
    isVisibleColumn(name) {
      return this.visibleColumns.find((item) => item.id === name).visible
    },
    calcColumnWidth() {
      return `min-width:calc(150px * ${this.countVisibleColumns})`
    },
    getPathToUpdate(key) {
      const prevRoute = url.getRoute(this.$route, true)
      const query = { prevRoute }
      return {
        name: 'atu.objects.update',
        params: { id: key },
        query,
      }
    },
    setEditedPopulations(item) {
      this.editedPopulations.push(item.join('_'))
    },
    setEditedParameter(item, parameter) {
      this.editedParameters[parameter].push(item.join('_'))
    },
    async setPopulationValue(event, id, year) {
      await this.$store.dispatch('updateModel', {
        url: atu.atuObjectDetail(id, year),
        data: {
          total_residents: event.target.value,
        },
      })
      const index = this.editedPopulations.findIndex(
        (item) => item === `${id}_${year}`
      )
      this.editedPopulations.splice(index, 1)
      this.getData()
    },
    async setParameter(event, [geo_object_id, fkko_id, year], parameter) {
      await this.$store.dispatch('createModel', {
        url: atu.wasteGenerationUpsert(),
        data: {
          year,
          fkko_id,
          geo_object_id,
          [parameter]: event.target.value,
        },
      })
      const index = this.editedParameters[parameter].findIndex(
        (item) => item === `${geo_object_id}_${fkko_id}_${year}`
      )
      this.editedParameters[parameter].splice(index, 1)
      this.getData()
    },
    setFkkoParameter(item, parameter) {
      this.editedParameters[parameter].push(item.join('_'))
    },
    countAllParameters(year, column) {
      let sum = this.fkkoYears[year][column.id]
      if (this.minusParameters[year] && this.minusParameters[year][column.id]) {
        sum -= this.minusParameters[year][column.id]
      }
      if (sum < 0) {
        sum = 0
      }
      return this.toFloatFixed(sum)
    },
  },
  created() {
    this.getData()
    window.addEventListener('click', this.outerClick)
  },
}
</script>
<style lang="scss">
.pointer {
  cursor: pointer;
}

.groupped-objects {
  .atu-table {
    background-color: #fff;
    height: 100%;
    max-height: 100%;
    border: 1px solid #d3dbe4;

    &__row {
      display: flex;
    }

    &__header {
      position: sticky;
      top: 0;
      z-index: 1;
    }

    &__head {
      padding: 5px;
      color: #72767a;
      min-width: 150px;
      max-width: 150px;
      border-bottom: 1px solid #d3dbe4;
      text-align: center;

      &_has-children {
        text-align: center;
      }

      &:first-child {
        min-width: 200px;
      }

      &:not(:last-child) {
        border-right: 1px solid #d3dbe4;
      }

      &:not(.atu-table__head_has-children) {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    &__head-inner {
      max-width: 150px;
      min-width: 150px;
      padding: 5px;
      color: #72767a;
      line-height: initial;
    }

    &__col,
    &__col-inner {
      padding: 5px;
      line-height: 32px;
      min-height: 43px;
    }

    &__col {
      min-width: 150px;
      max-width: 150px;
      border-bottom: 1px solid #d3dbe4;

      &:first-child {
        min-width: 200px;
        max-width: 200px;
      }

      &:nth-child(n + 2) {
        text-align: center;

        &:not(.atu-table__col_sticky) {
          max-width: 150px;
          min-width: 150px;
        }
      }

      &_sticky {
        position: sticky;
        min-width: 50px;
        max-width: 50px;
        right: 0;
        z-index: 1;
        background-color: #fff;
      }
    }

    &__mo-name {
      min-width: 200px;
      max-width: 200px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 18px;

      &_fkko {
        line-height: 16px;
      }
    }

    &__col-inner {
      margin-left: -5px;
      margin-right: -5px;
      max-height: 43px;

      &:not(:last-child) {
        border-bottom: 1px solid #d3dbe4;
      }
    }
  }

  .toolbar__line {
    align-items: flex-end;
  }

  &__long-row {
    width: auto;
    overflow: visible;
    max-width: initial;
  }

  .popup-list {
    position: relative;

    &__popup {
      right: auto;
      left: 0;
    }
  }

  .columns-list {
    position: relative;

    &__popup {
      right: auto;
      left: 0;
    }
  }

  .withMinHeight {
    min-height: 47px;
  }
}
</style>
